export const validStates = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
  "DC",
];

export function isUnitedStatesCountry(country: string | undefined): boolean {
  if (!country?.trim()) return false;
  const val = country.trim();
  const lower = val.toLowerCase();
  return (
    lower === "united states" ||
    lower === "united states of america" ||
    lower === "united states of america (usa)" ||
    lower === "us" ||
    lower === "usa" ||
    val === "US"
  );
}

const BLOCKED_US_RESIDENCE_STATE_NORMALIZED = new Set(["NY", "SD", "NEW YORK", "SOUTH DAKOTA"]);

/** NY and SD are not supported for US residence on the onboarding application. */
export function isUsResidenceStateBlockedForOnboarding(state: string | undefined): boolean {
  if (!state?.trim()) return false;
  return BLOCKED_US_RESIDENCE_STATE_NORMALIZED.has(state.trim().toUpperCase());
}
